function mix(a, b, t) {
  return (1.0 - t) * a + t * b;
}

export default mix;
